import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "bootstrap/dist/css/bootstrap.min.css";

import "font-awesome/css/font-awesome.min.css";
import "./assets/css/main.css";
import "./assets/css/animate.css";
import "./assets/css/astro-animation.css";
import "./assets/css/prettyPhoto.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js"; 
import "./assets/css/responsive.css";
import 'bootstrap/dist/css/bootstrap.min.css';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';



import "./assets/css/templatemo-style.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
// import "./assets/css/intro.css";
// import "./assets/css/global.css";
 
import "./assets/css/result_searchbar.css";
import AOS from "aos";
import "aos/dist/aos.css";
import i18n from "./i18n";

const app = createApp(App);
app.use(router);
app.use(store);
app.use(i18n);
app.mount("#app");
AOS.init({
  duration: 800,
  once: true,
});
